import {match, Pattern} from 'ts-pattern';

import {Nullish} from 'shared/web';

import {AgentMessageAvatar} from '../types/AgentMessageAvatar';

interface GetAgentMessageAvatarParams {
  /** `externalUserId` of the message sender. Absent for senders not backed by a DMS user. */
  senderUserId: string | Nullish;
  currentUserId: string | Nullish;
  /** The signed-in user's avatar, already resolved from the shared cache entry. */
  currentUserAvatarUrl: string | Nullish;
  /** Avatar uris of every agent other than the signed-in user, keyed by user id. */
  avatarUriByUserId: Map<string, string>;
}

/**
 * Decides where an agent message's avatar image comes from, preferring the signed-in user's already
 * cached avatar so their own messages render without waiting for another request.
 */
export function getAgentMessageAvatar(params: GetAgentMessageAvatarParams): AgentMessageAvatar {
  return match(params.senderUserId)
    .returnType<AgentMessageAvatar>()
    .with(Pattern.nullish, () => ({type: 'fetchByUri', avatarUri: null}))
    .with(
      Pattern.when((senderUserId) => senderUserId === params.currentUserId),
      () => ({
        type: 'resolvedUrl',
        imageUrl: params.currentUserAvatarUrl,
      })
    )
    .otherwise((senderUserId) => ({
      type: 'fetchByUri',
      avatarUri: params.avatarUriByUserId.get(senderUserId) ?? null,
    }));
}
